/* eslint-env browser, node */
// eslint-disable-next-line import/prefer-default-export
export const isSzepcel = process.env.REACT_APP_SZEPCEL || window.location.hostname.endsWith('szepcel.hu');
